export default {
  'comparison_analysis_title': "对比分析",
  'comparison_analysis_country_comparison_title': "国家对比",
  'comparison_analysis_country_comparison_key_global': "全球",

  'comparison_analysis_country_comparison_key_total': "全部",

  'comparison_analysis_country_comparison_key_metrics_ranking': "关键指标排名",

}
